import * as faceapi from '@vladmandic/face-api/dist/face-api.esm-nobundle.js'

const MODEL_URL = process.env.PUBLIC_URL + '/models'

export default function createFaceDetector() {
    let loaded = false
    let options = null

    return {
        id: 'face',
        label: 'Face Detection',
        accent: '#22c55e',

        async load() {
            if (loaded) return
            await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL)
            options = new faceapi.TinyFaceDetectorOptions({
                inputSize: 320,
                scoreThreshold: 0.4,
            })
            loaded = true
        },

        async detect({ video, vw, vh }) {
            if (!loaded || !vw || !vh) return null
            const dets = await faceapi.detectAllFaces(video, options)
            const boxes = dets.map((d, i) => {
                const b = d.box || d.detection?.box || {}
                return {
                    x: b.x / vw,
                    y: b.y / vh,
                    w: b.width / vw,
                    h: b.height / vh,
                    label: `Face ${i + 1}`,
                    score: d.score,
                }
            })
            return {
                boxes,
                insights: [
                    { label: 'Face Detection', value: boxes.length ? 'YES' : 'NO' },
                    { label: 'Face Count', value: boxes.length },
                ],
            }
        },

        reset() {},
        dispose() {},
    }
}
